import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { BaseDataSource, QueryResultsModel } from "../../_base/crud";
import { selectResidentialAdjustmentQueryResult, selectResidentialAdjustmentsPageLoading, selectResidentialAdjustmentsShowInitWaitingMessage } from "../_selectors/residential-adjustments.selectors";

export class ResidentialAdjustmentsDataSource extends BaseDataSource {
    trashed = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectResidentialAdjustmentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectResidentialAdjustmentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectResidentialAdjustmentQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        })
        
    }
}